export type CollectionsListPageTabsKeys = 'album' | 'albumcollection'
export const CollectionsListPageTabsKeysEnum: Record<
  CollectionsListPageTabsKeys,
  CollectionsListPageTabsKeys
> = {
  album: 'album',
  albumcollection: 'albumcollection',
} as const
export const DEFAULT_COLLECTIONS_LIST_PAGE_TAB: CollectionsListPageTabsKeys =
  'album'
export const CollectionsListPageTabsKeysArray: CollectionsListPageTabsKeys[] = [
  'album',
  'albumcollection',
]
